import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./notfound.scss";
import Logo from "../Logo/logo";

const NotFound = () => {
  useEffect(() => {
    // Add a class to the HTML element
    document.documentElement.classList.add("notfound-height");

    // Cleanup: Remove the class when the component is unmounted
    return () => {
      document.documentElement.classList.remove("notfound-height");
    };
  }, []);

  return (
    <div className="container-fluid">
        <div className="container">
            <div className="row">
                <div className="col">
                    <div className="notfound-container">
                    <Link to="/" className="logo"><Logo /></Link>
                    <h1>Expert Web Design &amp; Development</h1>
                    <h2>404</h2>
                    <p>Oops! This page doesn't exist.</p>
                    <Link to="/">Go to home page</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default NotFound;